import { generatePath } from 'react-router-dom';
import { API_URLS } from '../../../routes/urls';
import { StrOrNum } from '../../../types/util';
import { convertObjectToFormData } from '../../../utils/form';
import { apiSlice } from '../../apiSlice';
import { QueryErrorReturnValue } from '../../types';
import { UpdateProfileResponse } from '../profile/types';
import { addSnackbar } from '../snackbar/snackbarSlice';
import { userApi } from '../user/userSlice';
import { WishlistAddOrRemovePayload } from './types';

const wishlistApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateWishlists: builder.mutation<UpdateProfileResponse, WishlistAddOrRemovePayload>({
      query: ({ slug, method, ...otherInputs }) => ({
        url: generatePath(method === 'ADD' ? API_URLS.addToWishlist : API_URLS.removeFromWishlist, { slug }),
        method: 'POST',
        data: convertObjectToFormData(otherInputs as unknown as Record<string, string | StrOrNum[]>),
      }),
      async onQueryStarted({ user_id, slug }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data.success) {
            dispatch(
              userApi.util.updateQueryData('getProfile', { slug, userId: user_id }, (draft) => {
                draft.user = data.data.student;
              })
            );
          }
          dispatch(
            addSnackbar({
              severity: data.success ? 'success' : 'error',
              message: data.message,
            })
          );
        } catch (error) {
          const err = error as QueryErrorReturnValue;
          dispatch(
            addSnackbar({
              message: err.error.message,
              severity: 'error',
            })
          );
        }
      },
    }),
  }),
});

export const { useUpdateWishlistsMutation } = wishlistApi;
